import { Injectable, Component } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlMatchResult, UrlSegment, UrlTree } from "@angular/router";

export function legacyEcomMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const path = segments.map(segment => segment.path).join("/");
  return /^(order\/ecom|inventory\/ecom(?:\/(?:products|suppliers|collections))?|inventory\/attachments\/(?:products|suppliers))$/.test(path)
    ? { consumed: segments } : null;
}
@Component({ template: "" })
export class EcomLegacyRedirectComponent {}

@Injectable({ providedIn: "root" })
export class EcomLegacyRedirectGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
    const source = this.router.parseUrl(state.url);
    const queryParams = { ...source.queryParams };
    const path = state.url.split(/[?#]/)[0];
    let destination = "/ecom";
    if (path.startsWith("/inventory/")) {
      destination += path.endsWith("/suppliers") ? "/vendors" : path.endsWith("/collections") ? "/collections" : "/inventory";
    } else {
      const view = queryParams.view;
      if (["drafts", "financing", "fulfillment"].includes(view)) destination += "/" + view;
      delete queryParams.view;
    }
    return this.router.createUrlTree([destination], { queryParams, fragment: source.fragment });
  }
}

@Injectable({ providedIn: "root" })
export class ShopCartRedirectGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (route.queryParamMap.get("cartKind") !== "Shop") return true;
    const source = this.router.parseUrl(state.url);
    const queryParams = { ...source.queryParams };
    delete queryParams.cartKind;
    return this.router.createUrlTree(["/ecom/carts"], { queryParams, fragment: source.fragment });
  }
}
